module.exports = __webpack_public_path__ + "img/commvault.e4c22361.svg";